module.exports = __webpack_public_path__ + "assets/images/6aefb7e2c3f5f9f38c89274ee8c2b6d2.png";